module.exports = __webpack_public_path__ + "img/banner.6803ce7f.png";